"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollRequestAbortedError = exports.PollDurationError = exports.ServiceLimitFetchError = exports.ServiceTemplatesFetchError = exports.ScheduleDeletionError = exports.ScheduleUpdateError = exports.ScheduleCreationError = exports.SettingsUpdateError = exports.SettingsFetchError = exports.SettingsCreationError = exports.NotificationCreationError = exports.TemplateSearchError = exports.TemplateDeletionError = exports.TemplateUpdateError = exports.TemplateCreationError = exports.TemplateFetchError = exports.ReportSearchError = exports.ReportPollError = exports.ReportDownloadError = exports.ReportDeletionError = exports.ReportFetchError = exports.ReportCreationError = exports.InvalidRequestConfigError = exports.ReportsSDKError = void 0;
class ReportsSDKError extends Error {
    constructor(message) {
        message ? super(message) : super();
        this.name = 'ReportsSDKError';
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
exports.ReportsSDKError = ReportsSDKError;
class InvalidRequestConfigError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'InvalidRequestConfigError';
        this.message = message ? message : 'Invalid request parameters';
    }
}
exports.InvalidRequestConfigError = InvalidRequestConfigError;
class ReportCreationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportCreationError';
        this.message = message ? message : 'Could not create report';
    }
}
exports.ReportCreationError = ReportCreationError;
class ReportFetchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportFetchError';
        this.message = message ? message : 'Could not fetch report';
    }
}
exports.ReportFetchError = ReportFetchError;
class ReportDeletionError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportDeletionError';
        this.message = message ? message : 'Could not delete report';
    }
}
exports.ReportDeletionError = ReportDeletionError;
class ReportDownloadError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportDownloadError';
        this.message = message ? message : 'Could not download report';
    }
}
exports.ReportDownloadError = ReportDownloadError;
class ReportSearchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportSearchError';
        this.message = message ? message : 'Could not search reports';
    }
}
exports.ReportSearchError = ReportSearchError;
class ReportPollError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ReportPollError';
        this.message = message ? message : 'Could not poll report';
    }
}
exports.ReportPollError = ReportPollError;
class TemplateFetchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'TemplateFetchError';
        this.message = message ? message : 'Could not fetch template';
    }
}
exports.TemplateFetchError = TemplateFetchError;
class TemplateCreationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'TemplateCreationError';
        this.message = message ? message : 'Could not create template';
    }
}
exports.TemplateCreationError = TemplateCreationError;
class TemplateUpdateError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'TemplateUpdateError';
        this.message = message ? message : 'Could not update template';
    }
}
exports.TemplateUpdateError = TemplateUpdateError;
class TemplateDeletionError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'TemplateDeletionError';
        this.message = message ? message : 'Could not delete template';
    }
}
exports.TemplateDeletionError = TemplateDeletionError;
class TemplateSearchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'TemplateSearchError';
        this.message = message ? message : 'Could not search templates';
    }
}
exports.TemplateSearchError = TemplateSearchError;
class NotificationCreationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'NotificationCreationError';
        this.message = message ? message : 'Could not create notification';
    }
}
exports.NotificationCreationError = NotificationCreationError;
class SettingsCreationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'SettingsCreationError';
        this.message = message ? message : 'Could not create settings';
    }
}
exports.SettingsCreationError = SettingsCreationError;
class SettingsFetchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'SettingsFetchError';
        this.message = message ? message : 'Could not fetch settings';
    }
}
exports.SettingsFetchError = SettingsFetchError;
class SettingsUpdateError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'SettingsUpdateError';
        this.message = message || 'Could not update settings';
    }
}
exports.SettingsUpdateError = SettingsUpdateError;
class ScheduleCreationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ScheduleCreationError';
        this.message = message ? message : 'Could not create schedule';
    }
}
exports.ScheduleCreationError = ScheduleCreationError;
class ScheduleUpdateError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ScheduleUpdateError';
        this.message = message ? message : 'Could not update schedule';
    }
}
exports.ScheduleUpdateError = ScheduleUpdateError;
class ScheduleDeletionError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ScheduleDeletionError';
        this.message = message ? message : 'Could not delete schedule';
    }
}
exports.ScheduleDeletionError = ScheduleDeletionError;
class ServiceTemplatesFetchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ServiceTemplateFetchError';
        this.message = message ? message : 'Could not fetch service templates';
    }
}
exports.ServiceTemplatesFetchError = ServiceTemplatesFetchError;
class ServiceLimitFetchError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'ServiceLimitFetchError';
        this.message = message || 'Could not fetch service limits';
    }
}
exports.ServiceLimitFetchError = ServiceLimitFetchError;
class PollDurationError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'PollDurationError';
        this.message = message || 'Maximum polling duration reached';
    }
}
exports.PollDurationError = PollDurationError;
class PollRequestAbortedError extends ReportsSDKError {
    constructor(message) {
        super();
        this.name = 'PollRequestAbortedError';
        this.message = message || 'Polling request has been aborted';
    }
}
exports.PollRequestAbortedError = PollRequestAbortedError;
